import { defineComponent, openBlock, createElementBlock, Fragment, createElementVNode, createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 1,
  "data-ui": "promotional-and-clearance"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DisclaimerModal",
  props: {
    disclaimerName: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _ctx.disclaimerName === "Outlet" ? (openBlock(), createElementBlock(Fragment, {
        key: 0
      }, [_cache[0] || (_cache[0] = createElementVNode("p", {
        "data-ui": "outlet"
      }, " Discount based on comparable value of either the original price or cost of a comparable item. While supplies last. Intermediate markdowns may have been taken. ", -1)), _cache[1] || (_cache[1] = createElementVNode("h2", null, "About Outlet", -1)), _cache[2] || (_cache[2] = createElementVNode("p", null, " Our buyers use the co-op’s expertise and long-standing relationships to hand-pick the best deals available. Think end-of-season closeouts and previous-year models that work beautifully in real-world conditions. No outdated leftovers. Just great gear at great prices, every day of the year. It’s gear and clothing we believe in, stand behind and happily use ourselves. ", -1))], 64)) : _ctx.disclaimerName === "Promotional and Clearance" ? (openBlock(), createElementBlock("p", _hoisted_1, " Discount based on original price. Selection varies by location. While supplies last. Intermediate markdowns may have been taken. ")) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=DisclaimerModal2.mjs.map
